<div id="layout">
  <div>
    <header>
      <h2>{{ "settings.users" | transloco }}</h2>
    </header>

    <div id="search-row">
      <div class="keyword-filter">
        <div class="ui left fluid input">
          <i class="search icon user-input-icon"></i>
          <input
            type="text"
            [(ngModel)]="userSearch"
            placeholder="Search users"
          />
        </div>
      </div>
      <div
        class="ui primary background button"
        [ngClass]="{ loading: isExporting }"
        (click)="exportUserPermissions()"
      >
        {{ "settings.export-users" | transloco }}
      </div>
      <div
        class="ui primary background button"
        [ngClass]="{ loading: isSaving }"
        (click)="addUser()"
      >
        {{ "settings.add-user" | transloco }}
      </div>
      <div
        class="ui primary background button"
        [ngClass]="{ loading: isSaving }"
        (click)="save()"
      >
        {{ "settings.save" | transloco }}
      </div>
    </div>

    @if (users?.length == 0) {
    <div id="no-results">{{ "settings.no-users-found" | transloco }}</div>
    }
  </div>

  @if (!loading && users?.length > 0) {
  <div class="table-container">
    <table width="100%" id="list" cellspacing="0">
      <thead>
        <tr>
          <td></td>
          <td>{{ "settings.first-name" | transloco }}</td>
          <td>{{ "settings.last-name" | transloco }}</td>
          <td>{{ "settings.email" | transloco }}</td>
          <td>
            <div class="role">{{ "settings.super-admin" | transloco }}</div>
          </td>
          <td>
            <div class="role">{{ "settings.admin" | transloco }}</div>
          </td>
          <td>
            <div class="role">{{ "settings.client-admin" | transloco }}</div>
          </td>
          <td>
            <div class="role">{{ "settings.user" | transloco }}</div>
          </td>
          @for (group of userInfo.groups; track group) {
          <td>{{ group }}</td>
          }
        </tr>
      </thead>
      <tbody>
        @for (user of users | keyWord: ['role', 'firstName', 'lastName',
        'countriesKeyword']:userSearch; track user) {
        <tr>
          <td>
            @if (canEditRole(user)) {
            <div
              class="delete icon"
              (click)="removeUser(user)"
              title="{{ 'settings.remove-user' | transloco }}"
            ></div>
            }
          </td>
          <td class="first-name">{{ user.firstName }}</td>
          <td class="last-name">{{ user.lastName }}</td>
          <td class="email">{{ user.email }}</td>
          <td class="is-super-admin">
            <input
              type="radio"
              name="{{ 'role' + user.id }}"
              [value]="'SUPER_ADMIN'"
              [(ngModel)]="user.role"
              (ngModelChange)="changeRole(user)"
              [disabled]="
                !userInfo.isSuperAdmin ||
                (isOnlyOneSuperAdmin && isSuperAdmin(user))
              "
            />
          </td>
          <td class="is-admin">
            <input
              type="radio"
              name="{{ 'role' + user.id }}"
              [value]="'COUNTRY_ADMIN'"
              [(ngModel)]="user.role"
              (ngModelChange)="changeRole(user)"
              [disabled]="!canEditRole(user)"
            />
          </td>
          <td class="is-client-admin">
            <input
              type="radio"
              name="{{ 'role' + user.id }}"
              [value]="'CLIENT_ADMIN'"
              [(ngModel)]="user.role"
              (ngModelChange)="changeRole(user)"
              [disabled]="!canEditRole(user)"
            />
          </td>
          <td class="is-user">
            <input
              type="radio"
              name="{{ 'role' + user.id }}"
              [value]="'USER'"
              [(ngModel)]="user.role"
              (ngModelChange)="changeRole(user)"
              [disabled]="!canEditRole(user)"
            />
          </td>
          @for (group of userInfo.groups; track group) {
          <td>
            <div class="ui checkbox">
              <input
                type="checkbox"
                [(ngModel)]="user[group]"
                (ngModelChange)="changeGroup(user)"
                [disabled]="!canEditGroup(user)"
              />
              <label></label>
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
